import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrecisionPipe } from './precision.pipe';



@NgModule({
  declarations: [
    PrecisionPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PrecisionPipe
  ]
})
export class PrecisionModule { }
